export * from './notice.component'
